import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import type { CountryCode } from 'libphonenumber-js/types';
import GooglePlacesApi from '@/modules/googleAutocomplete/services/GooglePlacesApi';
import { Address } from '@/modules/multiForm/shared/MultiformModels';
import GoogleAutocompletePrediction from '@/modules/googleAutocomplete/GoogleAutocompletePrediction';
import { AutocompletePlacesTypes } from '@/modules/googleAutocomplete/enums/AutocompletePlacesTypes';
import { addressFormat } from '@/composables/useFilters';
import { useInstance } from '@/composables/useInstance';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddressAutocomplete',
  props: {
    addresses: { default: () => [] },
    label: null,
    type: { default: AutocompletePlacesTypes.CITIES_AND_ROUTES },
    disabled: { type: Boolean, default: false },
    includedRegionCodes: { default: () => [] }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: Address): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { addresses: Address[], label?: string, type: AutocompletePlacesTypes, disabled: boolean, includedRegionCodes: CountryCode[] };

const { $i18n } = useInstance();



const resolvedLabel = computed(() => props.label ?? $i18n.useAddressAutocomplete.SEARCH_ADDRESS);



const searchInput = ref('');
const stateList = ref<GoogleAutocompletePrediction[]>([]);

async function getList(value: string): Promise<void> {
  if (value && value.length > 1) {
    const response = await GooglePlacesApi.getAddressesByInput(
      value,
      props.type,
      props.includedRegionCodes,
    );
    if (response) {
      stateList.value = response;
    }
  }
}

function formatAddress(address: Address): string {
  return addressFormat(address);
}

async function onInput(addressObject: GoogleAutocompletePrediction | Address): Promise<void> {
  if ('place_id' in addressObject && addressObject.place_id) {
    const response = await GooglePlacesApi.getAddress(addressObject.place_id, addressObject.description);
    emit('input', response);
  } else {
    emit('input', addressObject as Address);
    searchInput.value = '';
  }
}

return { __sfc: true,$i18n, props, resolvedLabel, emit, searchInput, stateList, getList, formatAddress, onInput }
}

})